import { ArticleModel } from "../../api-clients/product-api-v1"
import { requiredAttrCodesForMicrodata } from "../constants/constants"
import { BreadcrumbItemType } from "../types/global"
import { SchemaOrgBreadcrumbsType, SchemaOrgProductType } from "../types/schemaOrg"

type ProductDataProps = {
  productName: string
  productBrand: string
  productKey: string
  url: string
  articlesList: ArticleModel[]
}

const prepareStructuredMicrodataForPDP = ({
  productBrand,
  productName,
  productKey,
  url,
  articlesList,
}: ProductDataProps): SchemaOrgProductType => {
  const variants = articlesList?.map((art) => {
    const colour = art.attributeValues
      ?.find((a) => a.key === requiredAttrCodesForMicrodata.COLOUR)
      ?.value?.replaceAll("<br/>", " ")
      .replaceAll("\n", " ")
    const material = art.attributeValues
      ?.find((a) => a.key === requiredAttrCodesForMicrodata.MATERIAL)
      ?.value?.replaceAll("<br/>", " ")
      .replaceAll("\n", " ")

    const variant = {
      "@type": "Product",
      name: productName,
      mpn: art.key,
      inProductGroupWithID: productKey,
      ...(colour && { color: colour }), // add key only if the value is defined
      ...(material && { material: material }),
    }
    return variant
  })

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ProductGroup",
    name: productName,
    brand: {
      "@type": "Brand",
      name: productBrand,
    },
    productGroupID: productKey,
    url: url,
    hasVariant: variants,
  }
  return structuredData
}

const prepareStructuredMicrodataForBreadcrumbs = (
  crumbs: BreadcrumbItemType[],
  url: string
): SchemaOrgBreadcrumbsType => {
  // The first item always has to point to the homepage
  const home = [
    {
      "@type": "ListItem",
      position: 1,
      item: {
        "@id": url,
        name: "Home",
      },
    },
  ]

  const breadcrumbItems = crumbs?.reduce((acc, next, index) => {
    // The last item has no item key - only a name
    if (index === crumbs.length - 1) {
      return acc.concat({
        "@type": "ListItem",
        position: index + 2,
        name: next?.name,
      })
    }
    return acc.concat({
      "@type": "ListItem",
      position: index + 2,
      item: {
        "@id": url + next?.href,
        name: next?.name,
      },
    })
  }, [])

  const items = home.concat(breadcrumbItems)

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items,
  }
  return structuredData
}

export { prepareStructuredMicrodataForPDP, prepareStructuredMicrodataForBreadcrumbs }
